import { InitSearchFieldTime } from "../times";
import { CookieBanner } from "../helper";
import { COOKIE } from "../types/cookie/constants";

export abstract class TrackSessionStart {
  static set sended(value: boolean) {
    window.o_util.cookie.set(COOKIE.SESSION_START_SENDED, value + "");
  }

  static get isSended(): boolean {
    return window.o_util.cookie.get(COOKIE.SESSION_START_SENDED) == "true";
  }

  static get sessionStart(): number | undefined {
    const sessionStart = window.o_util.cookie.get(COOKIE.SESSION_START);
    if (!sessionStart) {
      return;
    }
    return Number(sessionStart);
  }

  static updateLabel(): number | undefined {
    let initialSearchBoxTime: number | undefined = undefined;
    const sessionStart = Number(window.o_util.cookie.get(COOKIE.SESSION_START));
    const currentTime = new Date().getTime();
    const sessionTime = currentTime - sessionStart;
    const ttl = 7200000;
    if (sessionTime > ttl) {
      window.o_util.cookie.set(COOKIE.SESSION_START, InitSearchFieldTime.navigationStart + "");
      this.sended = false;
    }

    if (!this.isSended && InitSearchFieldTime.countMeasures > 0) {
      initialSearchBoxTime = (InitSearchFieldTime.measurePerfEntries.pop() as PerformanceEntry).duration;
      this.sended = true;
    }
    return initialSearchBoxTime;
  }

  static init() {
    if (CookieBanner.isEnabled() && !this.sessionStart) {
      window.o_util.cookie.set(COOKIE.SESSION_START, InitSearchFieldTime.navigationStart + "");
      TrackSessionStart.sended = false;
    }
  }
}
